module.exports = __webpack_public_path__ + "img/wxgzhgz.249d8047.png";